import React, { Component } from "react";
import "./ChooseTimeline.css";

const BASE_LEFT = 250;
const BASE_TRIM_LEFT = 247;
const BASE_TRIM_MAX_LEFT = 787;
const TRIM_MS_PER_PX = 37.037037037;
const TRIMED_ANIMATION_DURATION = 10 * 1000;
const PX_PER_SEC = 27;
const TICK_TIME_MS = 30;
const MAX_ANIM_DURATION_SEC = 30;
const MAX_ANIM_DURATION_NSEC = MAX_ANIM_DURATION_SEC * 1000;
class ChooseTimeline extends Component {
  constructor(props) {
    super(props);
    this.progressElem = React.createRef();
    this.trimElem = React.createRef();

    // タイムラインの制御
    this.isTimelineMove = false;
    this.timelineMouseDown = this.timelineMouseDown.bind(this);
    this.timelineMouseUp = this.timelineMouseUp.bind(this);
    this.timelineMouseMove = this.timelineMouseMove.bind(this);

    // タイムラインバーの制御
    this.currentTime = 0;
    this.isPlaying = false;
    this.timerHandler = undefined;

    // トリムの制御
    this.trimMovingInfo = {
      startX: 0,
      startLeft: 0,
    };
    this.trimMouseUp = this.trimMouseUp.bind(this);
    this.trimMouseMove = this.trimMouseMove.bind(this);

    // トリム再生の制御
    this.trimStartMs = 0;
    this.isTrimPlaying = false;

    this.state = {
      isPlaying: false,
    };
  }

  componentWillUnmount() {
    if (this.timerHandler) window.clearInterval(this.timerHandler);
  }

  playTimeline() {
    // 自動再生の開始
    this.isPlaying = true;
    const startCurrentTime = this.currentTime;
    const startBaseTime = new Date();
    this.timerHandler = window.setInterval(() => {
      if (startCurrentTime === undefined || !startBaseTime) {
        window.clearInterval(this.timerHandler);
      }
      let diff = new Date() - startBaseTime;
      this.currentTime = startCurrentTime + diff;
      if (this.currentTime > MAX_ANIM_DURATION_NSEC) {
        window.clearInterval(this.timerHandler);
        this.timerHandler = undefined;
        this.props.pusePreview();
        this.props.changeTime(MAX_ANIM_DURATION_NSEC);
        return;
      }
      if (this.isTrimPlaying && diff > TRIMED_ANIMATION_DURATION) {
        window.clearInterval(this.timerHandler);
        this.timerHandler = undefined;
        this.props.pusePreview();
        this.props.changeTime(this.trimStartMs + TRIMED_ANIMATION_DURATION);
        this.trimStartMs = 0;
        this.isTrimPlaying = false;
        this.setState({
          isPlaying: false,
        });
      }
      if (!this.isPlaying) {
        console.log("is playing is false");
      }
      if (!this.progressElem.current) {
        window.clearInterval(this.timerHandler);
        return;
      }
      let div = this.progressElem.current;
      if (!div) {
        window.clearInterval(this.timerHandler);
        return;
      }
      div.style.left = BASE_LEFT + (this.currentTime / 1000) * PX_PER_SEC + "px";

      this.props.changeTime(this.currentTime);
    }, TICK_TIME_MS);
  }

  pauseProgress() {
    if (this.timerHandler) {
      window.clearInterval(this.timerHandler);
      this.timerHandler = undefined;
      this.props.changeTimeWithAnimControl(this.currentTime);
    }
  }

  backToZero() {
    this.currentTime = 0;
    if (!this.progressElem.current) return;
    let div = this.progressElem.current;
    div.style.left = BASE_LEFT + "px";
    this.props.changeTime(0);
    this.props.changeTimeWithAnimControl(0);

    this.isTrimPlaying = false;
  }

  // 以下タイムラインバーのマウス制御
  timelineMouseDown(e) {
    this.isTimelineMove = true;
    window.addEventListener("mouseup", this.timelineMouseUp);
    window.addEventListener("mousemove", this.timelineMouseMove);
    if (this.timerHandler) {
      window.clearInterval(this.timerHandler);
      this.timerHandler = undefined;
      this.isPlaying = false;
    }
    e.preventDefault();
  }

  timelineMouseUp(e) {
    this.isTimelineMove = false
    window.removeEventListener('mouseup', this.timelineMouseUp)
    window.removeEventListener('mousemove', this.timelineMouseMove)
    let diff = ((e.clientX - BASE_LEFT - this.props.leftMargin) / PX_PER_SEC) * 1000
    if (diff < 0) diff = 0
    if (diff > MAX_ANIM_DURATION_NSEC) diff = MAX_ANIM_DURATION_NSEC
    this.props.changeTime(diff)
  }

  timelineMouseMove(e) {
    let left = e.clientX - this.props.leftMargin
    if (left < BASE_LEFT) {
      left = BASE_LEFT;
    }
    if (left > 1060) {
      left = 1060;
    }
    let div = this.progressElem.current;
    div.style.left = left + "px";
    let diff = ((left - BASE_LEFT) / PX_PER_SEC) * 1000;
    this.props.changeTimeWithAnimControl(diff);
    this.currentTime = diff;
  }
  // プログレスバー移動によるタイムライン時間の変更
  changeTime(time_ms) {
    this.props.changeTimeWithAnimControl(time_ms);
  }

  trimMouseDonw(e) {
    let left = getComputedStyle(this.trimElem.current).left;
    this.trimMovingInfo.left = !left ? 0 : left.substr(0, left.indexOf("px"));
    this.trimMovingInfo.startX = e.clientX;
    window.addEventListener("mouseup", this.trimMouseUp);
    window.addEventListener("mousemove", this.trimMouseMove);
  }

  trimMouseUp(e) {
    let left = getComputedStyle(this.trimElem.current).left;
    left = !left ? 0 : left.substr(0, left.indexOf("px"));
    if (left < BASE_TRIM_LEFT) left = BASE_TRIM_LEFT;
    if (left > BASE_TRIM_MAX_LEFT) left = BASE_TRIM_MAX_LEFT;
    this.trimElem.current.style.left = left + "px";

    this.trimMovingInfo.left = 0;
    this.trimMovingInfo.startX = 0;
    window.removeEventListener("mouseup", this.trimMouseUp);
    window.removeEventListener("mousemove", this.trimMouseMove);
  }

  trimMouseMove(e) {
    let left = this.trimMovingInfo.left - (this.trimMovingInfo.startX - e.clientX);
    if (left < BASE_TRIM_LEFT) left = BASE_TRIM_LEFT;
    if (left > BASE_TRIM_MAX_LEFT) left = BASE_TRIM_MAX_LEFT;
    this.trimElem.current.style.left = left + "px";
  }

  getCurrentStartTimeMS() {
    let left = getComputedStyle(this.trimElem.current).left;
    left = !left ? 0 : left.substr(0, left.indexOf("px"));
    const diffPx = left - BASE_TRIM_LEFT;
    const ms = Math.ceil(diffPx * TRIM_MS_PER_PX);
    return ms;
  }

  setChooseDelay(time) {
    const left = time / TRIM_MS_PER_PX + BASE_TRIM_LEFT;
    this.trimElem.current.style.left = left + "px";
  }

  // Play 10 s
  play10Sec(e) {
    this.props.pusePreview();
    const ms = this.getCurrentStartTimeMS();
    this.props.changeTime(ms);
    this.props.changeTimeWithAnimControl(ms);
    this.currentTime = ms;
    this.isTrimPlaying = true;
    this.trimStartMs = ms;
    let progressLeft = (ms / 1000) * PX_PER_SEC + BASE_LEFT;
    let div = this.progressElem.current;
    div.style.left = progressLeft + "px";
    this.setState({
      isPlaying: true,
    });
    setTimeout(() => {
      this.props.playPreview();
    }, 10);
  }

  // Stop 10 s
  stop10Sec() {
    console.log("stop10sec");
    window.clearInterval(this.timerHandler);
    this.timerHandler = undefined;
    this.props.pusePreview();
    this.trimStartMs = 0;
    this.isTrimPlaying = false;
    this.setState({
      isPlaying: false,
    });
  }

  render() {
    return (
      <div id="timeline-30-main">
        <div id="timeline-30">
          <div id="tick-30" className="seek-row-30">
            <div className="header-30"></div>
            <div className="body-30">
              <div>00s</div>
              <div>
                <p></p>
              </div>
              <div>02s</div>
              <div>
                <p></p>
              </div>
              <div>04s</div>
              <div>
                <p></p>
              </div>
              <div>06s</div>
              <div>
                <p></p>
              </div>
              <div>08s</div>
              <div>
                <p></p>
              </div>
              <div>10s</div>
              <div>
                <p></p>
              </div>
              <div>12s</div>
              <div>
                <p></p>
              </div>
              <div>14s</div>
              <div>
                <p></p>
              </div>
              <div>16s</div>
              <div>
                <p></p>
              </div>
              <div>18s</div>
              <div>
                <p></p>
              </div>
              <div>20s</div>
              <div>
                <p></p>
              </div>
              <div>22s</div>
              <div>
                <p></p>
              </div>
              <div>24s</div>
              <div>
                <p></p>
              </div>
              <div>26s</div>
              <div>
                <p></p>
              </div>
              <div>28s</div>
              <div>
                <p></p>
              </div>
              <div>30s</div>
            </div>
          </div>
          <div id="video-seek-30" className="seek-row-30">
            <div className="header-30">
              <img src="/camera2.svg" alt="camera svg"></img>
              <p style={{ marginTop: "27px" }}>Video</p>
            </div>
            <div className="body-30">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <div id="text-seek-30" className="seek-row-30">
            <div className="header-30">
              <img src="/text_effect_icon_gray2.svg" alt="text effect icon"></img>
              <p>Text Effect</p>
              <p className='tooltiptext'>テキストエフェクト</p>
            </div>
            <div className="body-30" ref={this.textEffectElem}></div>
          </div>
          <div id="visual-seek-30" className="seek-row-30">
            <div className="header-30">
              <img src="/visual_effect_icon_gray2.svg" alt="visual effect icon svg"></img>
              <p>Visual Effect</p>
              <p className='tooltiptext'>ビジュアルエフェクト</p>
            </div>
            <div className="body-30" ref={this.visualEffectElem}></div>
            <div className="trash-space-30"></div>
          </div>
          <div id="sound-seek-30" className="seek-row-30">
            <div className="header-30">
              <img src="/sound_icon2.svg" alt="sound icon svg"></img>
              <p>Sound Effect</p>
              <p className='tooltiptext'>サウンドエフェクト</p>
            </div>
            <div className="body-30" ref={this.soundEffectElem}></div>
          </div>
        </div>
        <div
          id="progressbar-30"
          ref={this.progressElem}
          onMouseDown={(e) => this.timelineMouseDown(e)}
        >
          <div>
            <p>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13"
                height="202"
                fill="none"
                viewBox="0 0 13 202"
              >
                <path fill="#DBC44E" d="M0 0v3.3L4.73 11h.77v191h2V11h.77L13 3.3V0H0z" />
              </svg>
            </p>
          </div>
        </div>
        <div id="choose-pane-30" ref={this.trimElem} onMouseDown={(e) => this.trimMouseDonw(e)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="290"
            height="106"
            fill="none"
            viewBox="0 0 290 106"
          >
            <path
              fill="#DBC44E"
              d="M0 0v96c0 5.52 4.48 10 10 10h270c5.52 0 10-4.48 10-10V0H0zm10 46V4h270v42H10z"
            />
            <path
              fill="#000"
              d="M27.12 78.344c0 .702-.054 1.674-.144 2.304h2.214c-.09-.648-.144-1.746-.144-2.304v-5.562c1.98.648 4.914 1.782 6.804 2.808l.81-1.962c-1.8-.882-5.22-2.16-7.614-2.88V67.94c0-.63.072-1.422.126-2.016h-2.214c.108.612.162 1.44.162 2.016v10.404zm26.298-12.132h-2.142c.054.468.108 1.008.108 1.656v3.096c0 3.15-.234 4.554-1.494 5.994-1.116 1.224-2.61 1.908-4.32 2.34l1.494 1.566c1.314-.432 3.132-1.26 4.302-2.628 1.332-1.512 1.98-3.042 1.98-7.164v-3.204c0-.648.036-1.188.072-1.656zm-8.352.144h-2.07c.054.378.072 1.008.072 1.332v6.03c0 .522-.054 1.152-.072 1.458h2.07c-.036-.36-.072-.99-.072-1.458v-6.03c0-.504.036-.954.072-1.332zm17.316-.198l-.666 1.692c2.52.324 7.398 1.404 9.54 2.196l.738-1.764c-2.268-.792-7.254-1.818-9.612-2.124zm-.81 4.806l-.666 1.71c2.61.396 7.092 1.422 9.18 2.214l.702-1.746c-2.25-.81-6.714-1.764-9.216-2.178zm-.954 5.202l-.72 1.764c2.898.432 8.406 1.656 10.8 2.682l.792-1.764c-2.466-.954-7.83-2.214-10.872-2.682zm18.81-9.576l-1.314 1.404c1.332.9 3.564 2.862 4.5 3.816l1.422-1.458c-1.008-1.044-3.348-2.916-4.608-3.762zm-1.854 12.042l1.206 1.854c2.79-.504 5.076-1.566 6.894-2.682 2.808-1.728 5.022-4.176 6.318-6.516l-1.098-1.962c-1.098 2.304-3.348 5.004-6.246 6.786-1.728 1.062-4.068 2.07-7.074 2.52zm29.538-13.176l-1.152.486c.486.684 1.062 1.764 1.422 2.484l1.188-.504c-.36-.702-1.008-1.818-1.458-2.466zm2.034-.774l-1.152.486c.504.684 1.098 1.71 1.476 2.484l1.17-.522a21.278 21.278 0 00-1.494-2.448zm-6.606 1.746l-2.088-.684a8.459 8.459 0 01-.666 1.62 15.396 15.396 0 01-5.652 5.958l1.584 1.17a18.64 18.64 0 004.554-4.392h5.634c-.324 1.512-1.404 3.78-2.736 5.31-1.602 1.854-3.744 3.456-7.218 4.482l1.674 1.512c3.366-1.296 5.544-2.952 7.2-4.986 1.62-1.98 2.682-4.392 3.168-6.12.126-.36.324-.81.504-1.098l-1.476-.9c-.342.108-.846.18-1.35.18h-4.338c.108-.162.18-.306.27-.468.198-.36.576-1.044.936-1.584zm20.196-.792h-2.07c.036.18.09.738.144 1.314.018.216.018.522.036.918-2.574.036-5.922.126-7.956.162l.054 1.728c2.232-.144 5.184-.252 7.92-.288 0 .522.018 1.062.018 1.53a3.598 3.598 0 00-1.008-.126c-1.818 0-3.348 1.35-3.348 3.24 0 2.052 1.566 3.132 3.024 3.132.468 0 .9-.09 1.26-.27-.864 1.386-2.52 2.178-4.644 2.646l1.53 1.512c4.266-1.242 5.544-4.068 5.544-6.462 0-.918-.216-1.746-.63-2.394 0-.81 0-1.854-.018-2.826 2.61 0 4.32.036 5.382.09l.036-1.692h-5.4c0-.36 0-.684.018-.9 0-.252.054-1.08.108-1.314zm-4.518 8.442c0-1.08.81-1.692 1.638-1.692.594 0 1.116.27 1.404.864.234 1.692-.468 2.43-1.404 2.43-.864 0-1.638-.612-1.638-1.602zm17.784 3.924c0-.54.558-1.026 1.314-1.026 1.188 0 1.98.918 2.124 2.232a9.592 9.592 0 01-1.278.072c-1.278 0-2.16-.486-2.16-1.278zm-2.628-11.466l.054 1.854c.414-.054.882-.09 1.332-.108.936-.054 4.05-.198 5.004-.234-.9.792-2.988 2.52-3.996 3.348-1.062.882-3.312 2.772-4.716 3.924l1.314 1.332c2.124-2.268 3.816-3.618 6.696-3.618 2.25 0 3.906 1.224 3.906 2.916 0 1.314-.666 2.286-1.908 2.826-.234-1.71-1.512-3.15-3.744-3.15-1.782 0-2.97 1.206-2.97 2.538 0 1.638 1.656 2.736 4.14 2.736 4.05 0 6.336-2.052 6.336-4.914 0-2.52-2.232-4.374-5.238-4.374-.72 0-1.44.09-2.16.306 1.278-1.044 3.492-2.916 4.41-3.6.378-.288.756-.54 1.134-.774l-.99-1.296c-.198.072-.522.108-1.152.162-.972.09-5.076.198-6.012.198-.432 0-.99-.018-1.44-.072zM148.782 80h7.56v-1.71h-2.592V66.734h-1.566c-.756.486-1.638.792-2.88 1.026v1.314h2.376v9.216h-2.898V80zm13.848.234c2.592 0 4.284-2.304 4.284-6.912 0-4.572-1.692-6.822-4.284-6.822-2.592 0-4.284 2.232-4.284 6.822 0 4.608 1.692 6.912 4.284 6.912zm0-1.638c-1.35 0-2.304-1.44-2.304-5.274 0-3.798.954-5.184 2.304-5.184 1.35 0 2.304 1.386 2.304 5.184 0 3.834-.954 5.274-2.304 5.274zm22.56-5.688c-.27-1.422-1.044-3.528-1.962-5.13l-1.458.468c.882 1.602 1.638 3.78 1.872 5.184l1.548-.522zm-4.248-7.992h-1.674v9.288c0 .216-.072.27-.306.288-.216 0-.918 0-1.692-.018.234.468.504 1.17.576 1.62 1.134.018 1.89-.054 2.412-.306.522-.288.684-.756.684-1.566v-9.306zm-4.32 3.006c-.324 1.962-.954 3.942-1.89 5.22.414.162 1.116.558 1.458.792.9-1.386 1.62-3.546 2.016-5.742l-1.584-.27zm-1.188 6.822c-.324-.414-1.854-1.98-2.376-2.43v-.828h2.106v-1.584h-2.106v-2.79a21.97 21.97 0 002.232-.702l-1.152-1.278c-1.35.594-3.618 1.116-5.616 1.44.198.36.414.918.486 1.296a32.716 32.716 0 002.43-.414v2.448h-2.772v1.584h2.556c-.684 1.908-1.836 4.05-2.898 5.274.252.396.648 1.08.81 1.548.81-1.008 1.638-2.556 2.304-4.194v7.272h1.62V73.97c.54.738 1.134 1.584 1.404 2.088l.972-1.314zm7.11-1.062c-1.08 3.582-3.51 5.382-7.758 6.174.36.414.738 1.062.918 1.548 4.626-1.116 7.254-3.204 8.46-7.29l-1.62-.432zM66.818 97h1.302v-9.17h3.108v-1.106H63.71v1.106h3.108V97zm5.403 0h1.274v-4.886c.504-1.302 1.288-1.75 1.918-1.75.308 0 .49.028.742.126l.238-1.12c-.238-.126-.476-.168-.812-.168-.854 0-1.624.616-2.156 1.582h-.042l-.112-1.386h-1.05V97zm5.427 0h1.274v-7.602h-1.274V97zm.644-9.17c.504 0 .854-.336.854-.854 0-.49-.35-.826-.854-.826s-.854.336-.854.826c0 .518.35.854.854.854zM81.504 97h1.274v-5.516c.7-.784 1.344-1.162 1.918-1.162.966 0 1.414.602 1.414 2.03V97h1.274v-5.516c.714-.784 1.33-1.162 1.918-1.162.966 0 1.414.602 1.414 2.03V97h1.274v-4.816c0-1.946-.742-2.982-2.31-2.982-.924 0-1.722.602-2.506 1.456-.308-.896-.938-1.456-2.1-1.456-.91 0-1.708.574-2.366 1.302h-.042l-.112-1.106h-1.05V97zm18.15 2.758l.798-.378c-1.218-1.988-1.792-4.354-1.792-6.734s.574-4.732 1.792-6.734l-.798-.364c-1.288 2.086-2.058 4.354-2.058 7.098 0 2.758.77 5.012 2.058 7.112zM102.27 97h5.628v-1.064h-2.058v-8.918h-.98c-.56.336-1.218.574-2.128.728v.826h1.82v7.364h-2.282V97zm10.426.182c1.988 0 3.192-1.862 3.192-5.208 0-3.332-1.204-5.138-3.192-5.138-1.988 0-3.206 1.792-3.206 5.138s1.218 5.208 3.206 5.208zm0-1.022c-1.176 0-1.96-1.26-1.96-4.186s.784-4.116 1.96-4.116c1.162 0 1.946 1.19 1.946 4.116 0 2.926-.784 4.186-1.946 4.186zm7.149 1.022c1.792 0 2.772-1.022 2.772-2.254 0-1.442-1.218-1.89-2.324-2.31-.854-.322-1.638-.588-1.638-1.316 0-.588.448-1.092 1.414-1.092.672 0 1.204.28 1.722.672l.616-.826c-.588-.462-1.414-.854-2.352-.854-1.652 0-2.632.952-2.632 2.156 0 1.288 1.162 1.806 2.226 2.198.84.322 1.736.658 1.736 1.442 0 .658-.49 1.19-1.498 1.19-.91 0-1.596-.364-2.254-.896l-.63.84c.728.602 1.764 1.05 2.842 1.05zm7.627 0c1.036 0 1.848-.35 2.52-.784l-.462-.84c-.56.378-1.162.602-1.904.602-1.442 0-2.436-1.036-2.52-2.66h5.124c.028-.182.056-.448.056-.728 0-2.17-1.092-3.57-3.024-3.57-1.764 0-3.43 1.54-3.43 4.004 0 2.506 1.624 3.976 3.64 3.976zm-2.38-4.606c.154-1.484 1.106-2.352 2.184-2.352 1.19 0 1.89.826 1.89 2.352h-4.074zm10.062 4.606c.91 0 1.778-.35 2.464-.966l-.56-.854c-.476.434-1.092.756-1.792.756-1.4 0-2.352-1.162-2.352-2.912s1.008-2.94 2.394-2.94c.602 0 1.064.28 1.512.672l.658-.84c-.546-.476-1.232-.896-2.226-.896-1.946 0-3.668 1.47-3.668 4.004 0 2.52 1.554 3.976 3.57 3.976zm4.225 2.576c1.302-2.1 2.072-4.354 2.072-7.112 0-2.744-.77-5.012-2.072-7.098l-.784.364c1.204 2.002 1.792 4.354 1.792 6.734s-.588 4.746-1.792 6.734l.784.378zM168.19 53.65l-.99.28c.07.22.13.43.2.64.72 3.71-.05 6.1-2.33 6.1-.99 0-1.85-.47-1.85-1.78 0-1.99 1.45-3.65 2.11-4.14.15-.08.38-.15.52-.2l-.3-.88c-.62.23-2.29.46-3.21.5-.18.01-.39.01-.55 0l.08 1.04c.21-.03.37-.06.57-.08.34-.05 1.08-.13 1.53-.2-.9 1.08-1.75 2.42-1.75 4.18 0 1.73 1.24 2.61 2.83 2.61 2.78 0 3.55-2.29 3.37-4.71.36.68.77 1.27 1.25 1.79l.65-.9c-1.5-1.36-1.93-3.02-2.13-4.25zm.88-.56l-.6.2c.22.4.45.98.62 1.44l.62-.22c-.15-.41-.44-1.03-.64-1.42zm1.05-.38l-.6.21c.23.4.47.97.64 1.43l.63-.22c-.18-.42-.46-1.03-.67-1.42zm3.63 7.51c0-.4.46-.63 1.19-.63.22 0 .44.02.65.06.01.16.01.31.01.44 0 .47-.25.74-.76.74-.68 0-1.09-.26-1.09-.61zm2.76-5.49h-1.08c.04.16.07.57.07.9v1.52c0 .46.03 1.09.06 1.68-.17-.02-.34-.03-.51-.03-1.4 0-2.19.58-2.19 1.47 0 .96.9 1.43 2.1 1.43 1.2 0 1.61-.62 1.61-1.3 0-.12 0-.27-.01-.44.76.34 1.42.87 1.9 1.37l.54-.87a6.545 6.545 0 00-2.49-1.44c-.03-.65-.07-1.35-.07-1.8v-.14c.68-.01 1.74-.06 2.43-.13l-.02-.88c-.69.09-1.74.14-2.41.15v-.6c0-.31.03-.72.07-.89zm11.54 2.97c0 1.69-1.67 2.58-4.12 2.88l.57.97c2.68-.39 4.64-1.66 4.64-3.81 0-1.49-1.08-2.33-2.57-2.33-1.16 0-2.29.3-3.01.47-.31.07-.69.13-.99.16l.31 1.14c.26-.1.59-.23.89-.32.56-.16 1.54-.5 2.68-.5.99 0 1.6.57 1.6 1.34zm-4.09-4.64l-.15.96c1.14.2 3.22.4 4.35.47l.16-.97c-1.01-.01-3.23-.21-4.36-.46z"
            />
            {this.state.isPlaying ? (
              <g
                onClick={(e) => {
                  this.stop10Sec(e);
                }}
                id="stop-button-10s"
              >
                <rect width="70" height="40" x="206" y="56" fill="#303233" rx="5" />
                <path fill="#C4C4C4" d="M232 67h4v19h-4zM247 67h4v19h-4z" />
              </g>
            ) : (
              <g
                onClick={(e) => {
                  this.play10Sec(e);
                }}
                id="play-button-10s"
              >
                <rect width="70" height="40" x="206" y="56" fill="#303233" rx="5" />
                <path fill="#fff" d="M253 76.41L234 67v18l19-8.59z" />
              </g>
            )}
          </svg>
        </div>
        <div id="trash-30" ref={this.trashElem}>
          <img src="/trash.svg" alt="trash"></img>
        </div>
      </div>
    );
  }
}

export default ChooseTimeline;
